import { browser } from '$app/environment';
import { endOfYear, format } from 'date-fns';
import { derived, writable, type Writable } from 'svelte/store';

const SEPARATOR = '||';

const createStore = <T extends string | number>(key: string, fallbackValue: T): Writable<T> => {
	let initialValue: string | number;
	let searchParams;

	if (browser) {
		searchParams = new URLSearchParams(window.location.search);

		if (searchParams.has(key)) {
			if (typeof fallbackValue === 'string') {
				initialValue = searchParams.get(key);
			}
			if (typeof fallbackValue === 'number') {
				initialValue = parseInt(searchParams.get(key), 10);
			}
		} else {
			initialValue = fallbackValue;
		}
	} else {
		initialValue = fallbackValue;
	}

	const { set, update, subscribe } = writable(initialValue as T);

	return {
		set,
		update,
		subscribe,
	};
};

const createArrayStore = (key: string) => {
	let objectSet: Set<string> = new Set();
	let initialValue: string[];
	let searchParams;

	if (browser) {
		searchParams = new URLSearchParams(window.location.search);

		if (searchParams.has(key)) {
			initialValue = searchParams.get(key).split(SEPARATOR);
		} else {
			initialValue = [];
		}
	} else {
		initialValue = [];
	}

	const { set, update, subscribe } = writable(initialValue);

	return {
		set: (value: string[]) => {
			objectSet = new Set();
			value.forEach((id) => objectSet.add(id));

			set(value);
		},
		update,
		subscribe,
		remove: (id: string) => {
			if (objectSet.has(id)) {
				objectSet.delete(id);
			}
			const objectArray = [...objectSet];

			set(objectArray);
		},
	};
};
export const selectedYear = writable('');
export const query = createStore('query', '' as string);
export const filteredFrom = createStore('from', '' as string);
export const filteredTo = createStore('to', '' as string);
export const filteredDates = createArrayStore('dates');
export const filteredVenues = createArrayStore('venues');
export const filteredTask: Writable<Task | ''> = createStore('task', '');
export const filterIsVisible = writable(false);

export const searchParams = derived(
	[query, filteredFrom, filteredTo, filteredDates, filteredVenues, filteredTask],
	([query, filteredFrom, filteredTo, filteredDates, filteredVenues, filteredTask]) => {
		const record = [
			['query', query + ''],
			['from', filteredFrom + ''],
			['to', filteredTo + ''],
			['dates', filteredDates.join(SEPARATOR)],
			['venues', filteredVenues.join(SEPARATOR)],
			['task', filteredTask + ''],
		].filter(([key, value]) => value);

		return new URLSearchParams(record);
	}
);

selectedYear.subscribe((value) => {
	if (value) {
		filteredFrom.set(`${format(new Date(parseInt(value, 10), 0, 1), 'yyyy-MM-dd')}`);
		filteredTo.set(`${format(endOfYear(new Date(parseInt(value, 10), 0, 1)), 'yyyy-MM-dd')}`);
	} else {
		filteredFrom.set('');
		filteredTo.set('');
	}
});
